import { render } from "./FleetClusters.vue?vue&type=template&id=45c5d5a2&scoped=true"
import script from "./FleetClusters.vue?vue&type=script&lang=js"
export * from "./FleetClusters.vue?vue&type=script&lang=js"

import "./FleetClusters.vue?vue&type=style&index=0&id=45c5d5a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c5d5a2"]])

export default __exports__